(function () {
  'use strict';

  function parseYouTubeId(raw) {
    if (!raw) return null;
    try {
      var u = new URL(raw, window.location.href);
      var host = u.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        return u.pathname.replace(/^\//, '').split('/')[0] || null;
      }
      if (host.indexOf('youtube.com') !== -1 || host.indexOf('youtube-nocookie.com') !== -1) {
        if (u.searchParams.get('v')) return u.searchParams.get('v');
        var parts = u.pathname.split('/').filter(Boolean);
        // /embed/ID, /shorts/ID, /live/ID
        if (parts.length >= 2 && (parts[0] === 'embed' || parts[0] === 'shorts' || parts[0] === 'live')) {
          return parts[1];
        }
      }
    } catch (e) {}
    // Last resort: try regex
    var m = String(raw).match(/(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function buildEmbedUrl(id) {
    // youtube-nocookie + parameters that suppress the title overlay,
    // controls, related videos, annotations, fullscreen and keyboard UI.
    var params = [
      'autoplay=1',
      'playsinline=1',
      'rel=0',
      'modestbranding=1',
      'controls=0',
      'disablekb=1',
      'fs=0',
      'iv_load_policy=3',
      'showinfo=0',
      'cc_load_policy=0'
    ].join('&');
    return (
      'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?' + params
    );
  }

  var overlay = null;

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'tp-yt-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<button type="button" class="tp-yt-overlay__close" aria-label="閉じる">×</button>' +
      '<div class="tp-yt-overlay__stage">' +
        '<div class="tp-yt-overlay__inner">' +
          '<div class="tp-yt-overlay__frame"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (
        e.target === overlay ||
        e.target.classList.contains('tp-yt-overlay__stage') ||
        e.target.classList.contains('tp-yt-overlay__close')
      ) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
    return overlay;
  }

  function open(videoId) {
    var o = ensureOverlay();
    var frame = o.querySelector('.tp-yt-overlay__frame');
    frame.innerHTML =
      '<iframe' +
      ' src="' + buildEmbedUrl(videoId) + '"' +
      ' frameborder="0"' +
      ' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"' +
      ' allowfullscreen' +
      ' title="YouTube video player"' +
      '></iframe>';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        o.classList.add('is-open');
        o.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tp-yt-overlay-open');
      });
    });
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.classList.remove('is-image');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tp-yt-overlay-open');
    // Stop video / drop image by clearing frame
    var frame = overlay.querySelector('.tp-yt-overlay__frame');
    if (frame) frame.innerHTML = '';
  }

  function pickRandom(arr) {
    if (!arr || !arr.length) return null;
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function openImage(src) {
    var o = ensureOverlay();
    var frame = o.querySelector('.tp-yt-overlay__frame');
    frame.innerHTML =
      '<img src="' + String(src).replace(/"/g, '&quot;') + '" alt="" class="tp-yt-overlay__image">';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        o.classList.add('is-open');
        o.classList.add('is-image');
        o.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tp-yt-overlay-open');
      });
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented) return;
      if (e.button !== undefined && e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // Find any archive container (yt or images)
      var container = e.target.closest && (
        e.target.closest('[data-yt-archive]') ||
        e.target.closest('[data-image-archive]')
      );
      if (!container) return;
      var trigger = e.target.closest('a, button');
      if (!trigger || !container.contains(trigger)) return;

      // Build separate pools so we can bias the type choice slightly
      // toward images while still picking uniformly within each type.
      var ytPool = [];
      var imgPool = [];
      var ytRaw = container.getAttribute('data-yt-archive') || '';
      ytRaw.split('|').map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (u) {
        var id = parseYouTubeId(u);
        if (id) ytPool.push(id);
      });
      var imgRaw = container.getAttribute('data-image-archive') || '';
      imgRaw.split('|').map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (u) {
        imgPool.push(u);
      });
      if (!ytPool.length && !imgPool.length) return;

      // Image bias: images get higher chance when both pools have entries.
      // 0.6 = 60% image / 40% video on each click.
      var IMAGE_BIAS = 0.6;
      var chosen;
      if (ytPool.length && imgPool.length) {
        if (Math.random() < IMAGE_BIAS) {
          chosen = { type: 'img', value: pickRandom(imgPool) };
        } else {
          chosen = { type: 'yt', value: pickRandom(ytPool) };
        }
      } else if (imgPool.length) {
        chosen = { type: 'img', value: pickRandom(imgPool) };
      } else {
        chosen = { type: 'yt', value: pickRandom(ytPool) };
      }
      e.preventDefault();
      e.stopPropagation();
      if (chosen.type === 'yt') {
        open(chosen.value);
      } else {
        openImage(chosen.value);
      }
    },
    true
  );
})();
